import React from 'react';
import { graphql, type HeadProps } from 'gatsby';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SEO from '../components/Storyblok/SEO';
import { useStoryblokSSG } from '../hooks';
import { PageData, PageSEO } from '../types';

type CookiePolicyPageProps = {
  data: PageData;
};

const CookiePolicy = ({ data = {} }: CookiePolicyPageProps) => {
  const { storyToRender } = useStoryblokSSG(data.storyblokEntry ?? null, { slug: 'cookie-policy' });

  return <div className="h-full">{storyToRender?.content && <StoryblokComponent blok={storyToRender.content} />}</div>;
};

export default CookiePolicy;

export const query = graphql`
  query CookiePolicyPageQuery {
    storyblokEntry(slug: { eq: "cookie-policy" }) {
      id
      internalId
      content
      name
      full_slug
    }
  }
`;

export function Head({ location, data = {} }: HeadProps<PageData>) {
  if (!data.storyblokEntry) return null;

  const content = JSON.parse(data.storyblokEntry.content) as PageSEO;
  const metaData = {
    title: content.metaDataTitle,
    description: content.metaDataDescription,
    image: content.metaDataImage?.filename,
    imageTwitter: content.metaDataImageTwitter?.filename,
    imageAltText: content?.metaDataImageAltText,
    location,
    fbDomainVerification: content.metaDataFbDomainVerification,
  };

  // @ts-expect-error SEO component is not typed
  return <SEO {...metaData} />;
}
